<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> User Master</h1>
            <button class="page-btn bg-theme" (click)="callRoute(17)">Add User</button>
            <div class="content-wrap min-ht500">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="ui celled table hover" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
                            <thead>
                                <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>User Email</th>
                                <th>Phone No.</th>
                                <th>Role</th>
                                <th>GST No.</th>
                                <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of users">
                                    
                                    <td>{{data.first_name}}</td>
                                    <td>{{data.last_name}}</td>
                                    <td>{{data.email}}</td>
                                    <td>{{data.phone_no}}</td>
                                    <td>{{data.role_name}}</td>
                                    <td>{{data.gstno}}</td>
                                    <td>
                                        <button class='action-btn2' (click)="passData(18,data)">Edit</button>
                                        <button class='action-btn' (click)="deleteUserData(data.id)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #showModalDeleteBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header bg-theme success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap2">
                    <img src="assets/images/delete.png" class="fa-icon-modal"
                        alt="img">
                    </span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Alert</h3>
                    <p class="reset-hd2">Are you sure you want to delete?</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="deleteUser()">Yes</button>
                </div>
                <div class="col-md-6">
                    <button class="approve-modal-btn3 mr-auto" data-dismiss="modal" (click)="refresh()">No</button> </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">{{successOrFailure}}</h3>
                    <p class="reset-hd2">{{delMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>


